import { NewsItem, NewsTypesItem } from '@cpd-app/generated';

export const newsFeatureKey = 'news';

export interface NewsState {
  loading: boolean;
  news: NewsItem[];
  newsTypes: NewsTypesItem[];
}

export const initialNewsState: NewsState = {
  loading: false,
  news: [],
  newsTypes: [],
};
